import {createStore} from "vuex"

import agent from './modules/agent'
import todo from './modules/todo' // 1. 引入待办任务模块
//创建store实例
const store=createStore({
    modules: {
        agent,
        todo
    },
    state(){
        return {
            pzName:'',
            pzId:'',
            zzjdIndex:null, //种植基地下标
            trObj:{}, //土壤设备
            address:[],
            trObjNum:0,
            zzjdNum:0,
            dialogNum:0,
            catch_components: [],
            formList:[],
            path:'',
            pageInfo:{},
            dialogVisibledetails:false,
            id:'',
            values:{},
            mapData:{
                data:[],
                mouseLocation: [0, 0],
                zoom: 13,
                range: [0, 0],
            },
            mapMes:{},
            maplist:[],
            shopCount:0,//店铺商城店铺数量
            categoryId:"",//店铺商城商品分类
            membId:"",//店铺商城店铺id
            categName:"",//店铺商城商品分类名称
            searchKeyWord:"",//店铺商城关键字查询
            "theme":'chalk',
            "module":"",
            "portalInfo":{},
            "color":"",
            "font":"",
            columnColor:'',
            columnFont:'',
            backgroundImage:'',
            TwonName:'',//乡镇名称
            timetick:'',//点击的时间
            // 大数据项目信息配置
            project:{
                scaling:100,
                backgroundImageSize:5,
                index:-1,
                projectShow:true,
                id:''
            },
            // 大数据组件及数据配置
            chartData:{
                componentList:[],
                canvasConfig:{
                    height:1080,
                    width:1920,
                    projectName:'',
                    background: null,
                    backgroundImage: null,
                    theme:'',
                },
                requestConfig:{
                    data:[
                        {
                            name:'年份',
                            label:'year',
                            value:'2024'
                        }
                    ]
                }
            },
            // 装修组件内容
            configData:{

            },
        }
    },
    mutations:{
        setpzName:(state, data) => {
            state.pzName = data
        },
        setpzId:(state, data) => {
            state.pzId = data
        },
        setAddress: (state, data) => {
            state.address = data
        },
        GET_CATCHE_COMPONENTS (state, data) {
            state.catch_components = data
        },
        setFormList (state, data) {
            state.formList = data
        },
        setPageInfo (state, data) {
            console.log(data)
            state.pageInfo = data
        },
        pathse (state, data) {
            state.path = data
        },
        mapDataChange (state, data) {
            state.mapData.data = data
        },
        mapConfigChange (state, data) {
            state.mapData.mouseLocation = [Number(data.mouseLocation[0].toFixed(5)),Number(data.mouseLocation[1].toFixed(5))]
            state.mapData.zoom = data.zoom
            state.mapData.range = data.range
        },
        mapMesChange (state, data) {
            state.mapMes = data
        },

        maplistmian (state, data) {
            state.maplist = data
        },

        dialogVisible (state, data) {
           
            // Visnle:false,
            // id:feature.id_
            state.dialogVisibledetails = data.Visnle
            state.id=data.id
            state.values=data.values
             state.dialogNum=data.num
             console.log(state.dialogNum,' console.log(state, data)')
           
             
        },
        trsbObj(state,data){
            state.trObj=data.values
             state.trObjNum=data.num
        },
        dktc(state,data){   //种植基地
            state.zzjdIndex=data.layerId
            console.log(data.num,'data.num')
            state.zzjdNum=data.num
        },
        shopCountChange(state, data) {
          state.shopCount = data
        },
        categoryIdChange(state, data) {
          state.categoryId = data
        },
        membIdChange(state, data) {
          state.membId = data
        },
        categNameChange(state, data) {
          state.categName = data
        },
        searchKeyWordChange(state, data) {
          state.searchKeyWord = data
        },
        setTheme(state,theme) {
          // 变更状态
          console.log(theme)
          state.theme = theme
        },
        setModule(state,module) {
          // 变更状态
          state.module = module
        },
        setColor(state,color) {
          // 变更状态
          state.color = color
        },
        setFont(state,font) {
          // 变更状态
          state.font = font
        },
        setPortalInfo(state,data) {
          // 变更状态
          state.portalInfo = data;
        },
        setColumnFont(state,columnFont) {
            // 变更状态
            state.columnFont = columnFont
        },
        setColumnColor(state,columnColor) {
            // 变更状态
            state.columnColor = columnColor
        },
        setBackgroundImage(state,backgroundImage) {
            // 变更状态
            state.backgroundImage = backgroundImage
        },
        setTwonName(state,TwonName) {
            // 变更状态
            state.TwonName = TwonName
        },
        setTimevalue(state,timetick) {
          // 变更状态
          state.timetick = timetick
        },
        //大数据相关
        setProject(state,data) {
            // 变更状态
            state.project = data
            console.log(state,data,'state,data')
        },
        setCanvasConfig(state,data) {
            // 变更状态
            state.chartData.canvasConfig = data
        },
        setChartData(state,data) {
            // 变更状态
           console.log(data,'datadatadata')
            state.chartData = data
        },
        setRequestConfig(state,data){
            data.forEach(element => {
                let j = state.chartData.requestConfig.data.find(item => item.label === element.label)
                if(j.value != element.value){
                    console.log('触发绑定')
                    j.value = element.value
                }
            });
        },
        setConfigData(state,data){
            console.log(data,'数据变更')
            state.configData = data
            console.log(state.configData,'数据变了')
        },
        setConfigDataList(state,data){
            state.configData.list[data.index] = data.data
        },
    }
})
export default store;